const types = {
  SEARCH: 'SEARCH',
  SEARCH_RESPONSE: 'SEARCH_RESPONSE',
  SEARCH_CLEAR: 'SEARCH_CLEAR',
}

export default types;